import React from 'react';
import times from 'lodash/times';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';

export const TaxesLoading = () => {
  return (
    <Box display="flex" flexDirection="column" style={{ gap: 24 }}>
      {times(2).map(key => (
        <React.Fragment key={key}>
          <Shimmer width={200} height={24} />

          {times(2).map(key1 => (
            <Box key={key1} display="flex" style={{ gap: 8 }}>
              <Shimmer width={24} height={24} />
              <Shimmer width={260} height={24} />
            </Box>
          ))}

          {times(2).map(key2 => (
            <Shimmer key={key2} width={332} height={36} />
          ))}
        </React.Fragment>
      ))}
    </Box>
  );
};
